const LS_ORDERS_KEY = 'restaurantes_mock_orders_v1';
/** Mapa: { [zoneId]: { [mesaId]: 'disponible' | 'ocupada', bar?: 'disponible' | 'ocupada' } } */
const LS_MESA_HABILITACION_KEY = 'restaurantes_mesa_habilitacion_v1';

export const MOCK_ZONAS = [
  {
    id: 1,
    nombreZona: 'Planta baja',
    tieneBarra: false,
    mesas: Array.from({ length: 12 }, (_, i) => i + 1),
  },
  {
    id: 2,
    nombreZona: 'Planta alta',
    tieneBarra: true,
    mesas: Array.from({ length: 18 }, (_, i) => i + 1),
  },
];

/** Mozos demo para asignar al pedido (luego vendrá de usuarios/API). */
export const MOCK_MOZOS = [
  { id: 'm1', nombre: 'María López' },
  { id: 'm2', nombre: 'Carlos Ruiz' },
  { id: 'm3', nombre: 'Ana Torres' },
];

export const MOCK_MENU = [
  {
    category: 'Entradas',
    items: [
      { id: 'e1', nombre: 'Papa a la huancaína', precio: 18.5 },
      { id: 'e2', nombre: 'Anticucho (unidad)', precio: 10.0 },
    ],
  },
  {
    category: 'Platos fuertes',
    items: [
      { id: 'p1', nombre: 'Pollo a la brasa', precio: 29.9 },
      { id: 'p2', nombre: 'Arroz chaufa', precio: 27.0 },
      { id: 'p3', nombre: 'Lomo saltado', precio: 34.5 },
    ],
  },
  {
    category: 'Bebidas',
    items: [
      { id: 'b1', nombre: 'Inca Kola (500ml)', precio: 8.0 },
      { id: 'b2', nombre: 'Jugo de naranja', precio: 10.0 },
    ],
  },
];

/**
 * Insumos por receta por ítem del menú (demo: 1 porción). Luego se enlaza a recetas reales / API.
 * cantidad = cantidad base; unidad; costoUnit = costo por unidad de medida (S/).
 */
export const MOCK_INSUMOS_RECETA = {
  e1: [
    { nombre: 'Papa', cantidad: 0.25, unidad: 'kg', costoUnit: 4.0 },
    { nombre: 'Ají amarillo', cantidad: 0.02, unidad: 'kg', costoUnit: 18.0 },
    { nombre: 'Queso fresco', cantidad: 0.04, unidad: 'kg', costoUnit: 22.0 },
    { nombre: 'Leche evaporada', cantidad: 0.08, unidad: 'L', costoUnit: 9.5 },
  ],
  e2: [
    { nombre: 'Carne de res (anticucho)', cantidad: 0.08, unidad: 'kg', costoUnit: 38.0 },
    { nombre: 'Corazón', cantidad: 4, unidad: 'und', costoUnit: 0.5 },
    { nombre: 'Adobo', cantidad: 0.02, unidad: 'kg', costoUnit: 15.0 },
  ],
  p1: [
    { nombre: 'Pollo entero', cantidad: 1.2, unidad: 'kg', costoUnit: 9.5 },
    { nombre: 'Sal y especias', cantidad: 0.02, unidad: 'kg', costoUnit: 15.0 },
    { nombre: 'Combustible (horno)', cantidad: 1, unidad: 'serv', costoUnit: 2.0 },
  ],
  p2: [
    { nombre: 'Arroz', cantidad: 0.25, unidad: 'kg', costoUnit: 4.5 },
    { nombre: 'Carne / pollo (trozos)', cantidad: 0.15, unidad: 'kg', costoUnit: 14.0 },
    { nombre: 'Sillao', cantidad: 0.03, unidad: 'L', costoUnit: 12.0 },
    { nombre: 'Huevo', cantidad: 2, unidad: 'und', costoUnit: 0.6 },
  ],
  p3: [
    { nombre: 'Lomo de res', cantidad: 0.22, unidad: 'kg', costoUnit: 42.0 },
    { nombre: 'Papa', cantidad: 0.2, unidad: 'kg', costoUnit: 4.0 },
    { nombre: 'Tomate / cebolla', cantidad: 0.08, unidad: 'kg', costoUnit: 6.0 },
    { nombre: 'Sillao', cantidad: 0.02, unidad: 'L', costoUnit: 12.0 },
  ],
  b1: [{ nombre: 'Gaseosa 500 ml', cantidad: 1, unidad: 'bot', costoUnit: 6.0 }],
  b2: [
    { nombre: 'Fruta (naranja)', cantidad: 0.35, unidad: 'kg', costoUnit: 8.0 },
    { nombre: 'Azúcar', cantidad: 0.01, unidad: 'kg', costoUnit: 5.0 },
    { nombre: 'Agua', cantidad: 0.2, unidad: 'L', costoUnit: 1.0 },
  ],
};

/**
 * Flujo cocina: pendiente → en_cocina (OP) → entrega_pendiente → entregado (cerrado en mesa).
 */
export const PRODUCCION_ESTADO = {
  pendiente: 'pendiente',
  en_cocina: 'en_cocina',
  entrega_pendiente: 'entrega_pendiente',
  entregado: 'entregado',
};

export const MOCK_INITIAL_ORDERS = [
  {
    id: 'ord-1',
    zoneId: 1,
    tipo: 'mesa',
    mesaId: 1,
    estado: 'abierto',
    mozo: 'María López',
    produccionEstado: 'pendiente',
    ordenProduccion: null,
    createdAt: new Date(Date.now() - 1000 * 60 * 45).toISOString(),
    items: [
      { itemId: 'p1', nombre: 'Pollo a la brasa', precio: 29.9, cantidad: 1 },
      { itemId: 'b2', nombre: 'Jugo de naranja', precio: 10.0, cantidad: 2 },
    ],
    observacion: '',
  },
  {
    id: 'ord-2',
    zoneId: 2,
    tipo: 'bar',
    mesaId: null,
    estado: 'abierto',
    mozo: 'Carlos Ruiz',
    produccionEstado: 'pendiente',
    ordenProduccion: null,
    createdAt: new Date(Date.now() - 1000 * 60 * 20).toISOString(),
    items: [{ itemId: 'e1', nombre: 'Papa a la huancaína', precio: 18.5, cantidad: 1 }],
    observacion: 'Sin hielo',
  },
  {
    id: 'ord-3',
    zoneId: 1,
    tipo: 'mesa',
    mesaId: 4,
    estado: 'abierto',
    mozo: 'Ana Torres',
    produccionEstado: 'pendiente',
    ordenProduccion: null,
    createdAt: new Date(Date.now() - 1000 * 60 * 15).toISOString(),
    items: [
      { itemId: 'p3', nombre: 'Lomo saltado', precio: 34.5, cantidad: 1 },
      { itemId: 'b1', nombre: 'Inca Kola (500ml)', precio: 8.0, cantidad: 2 },
    ],
    observacion: 'Sin cebolla',
  },
  {
    id: 'ord-4',
    zoneId: 2,
    tipo: 'mesa',
    mesaId: 9,
    estado: 'abierto',
    mozo: 'María López',
    produccionEstado: 'pendiente',
    ordenProduccion: null,
    createdAt: new Date(Date.now() - 1000 * 60 * 12).toISOString(),
    items: [
      { itemId: 'p2', nombre: 'Arroz chaufa', precio: 27.0, cantidad: 2 },
      { itemId: 'e2', nombre: 'Anticucho (unidad)', precio: 10.0, cantidad: 2 },
    ],
    observacion: '',
  },
  {
    id: 'ord-5',
    zoneId: 2,
    tipo: 'bar',
    mesaId: null,
    estado: 'abierto',
    mozo: 'Carlos Ruiz',
    produccionEstado: 'en_cocina',
    ordenProduccion: {
      id: 'OP-DEMO-0005',
      pedidoId: 'ord-5',
      fechaEnvioCocina: new Date(Date.now() - 1000 * 60 * 9).toISOString(),
      zonaNombre: 'Planta alta',
      mesaLabel: 'Barra',
      mozo: 'Carlos Ruiz',
      observacionPedido: 'Poco picante',
      items: [
        { itemId: 'p1', nombre: 'Pollo a la brasa', precio: 29.9, cantidad: 1, subtotal: 29.9 },
        { itemId: 'b2', nombre: 'Jugo de naranja', precio: 10.0, cantidad: 1, subtotal: 10.0 },
      ],
      total: 39.9,
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 11).toISOString(),
    items: [
      { itemId: 'p1', nombre: 'Pollo a la brasa', precio: 29.9, cantidad: 1 },
      { itemId: 'b2', nombre: 'Jugo de naranja', precio: 10.0, cantidad: 1 },
    ],
    observacion: 'Poco picante',
  },
  {
    id: 'ord-6',
    zoneId: 1,
    tipo: 'mesa',
    mesaId: 7,
    estado: 'abierto',
    mozo: 'Ana Torres',
    produccionEstado: 'en_cocina',
    ordenProduccion: {
      id: 'OP-DEMO-0006',
      pedidoId: 'ord-6',
      fechaEnvioCocina: new Date(Date.now() - 1000 * 60 * 6).toISOString(),
      zonaNombre: 'Planta baja',
      mesaLabel: 'Mesa 7',
      mozo: 'Ana Torres',
      observacionPedido: '',
      items: [
        { itemId: 'e1', nombre: 'Papa a la huancaína', precio: 18.5, cantidad: 2, subtotal: 37.0 },
        { itemId: 'p3', nombre: 'Lomo saltado', precio: 34.5, cantidad: 1, subtotal: 34.5 },
      ],
      total: 71.5,
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 8).toISOString(),
    items: [
      { itemId: 'e1', nombre: 'Papa a la huancaína', precio: 18.5, cantidad: 2 },
      { itemId: 'p3', nombre: 'Lomo saltado', precio: 34.5, cantidad: 1 },
    ],
    observacion: '',
  },
  {
    id: 'ord-7',
    zoneId: 2,
    tipo: 'mesa',
    mesaId: 12,
    estado: 'abierto',
    mozo: 'María López',
    produccionEstado: 'entrega_pendiente',
    ordenProduccion: {
      id: 'OP-DEMO-0007',
      pedidoId: 'ord-7',
      fechaEnvioCocina: new Date(Date.now() - 1000 * 60 * 25).toISOString(),
      fechaTerminadoCocina: new Date(Date.now() - 1000 * 60 * 4).toISOString(),
      zonaNombre: 'Planta alta',
      mesaLabel: 'Mesa 12',
      mozo: 'María López',
      observacionPedido: 'Sin ají',
      items: [
        { itemId: 'p2', nombre: 'Arroz chaufa', precio: 27.0, cantidad: 1, subtotal: 27.0 },
        { itemId: 'b1', nombre: 'Inca Kola (500ml)', precio: 8.0, cantidad: 1, subtotal: 8.0 },
      ],
      total: 35.0,
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 26).toISOString(),
    items: [
      { itemId: 'p2', nombre: 'Arroz chaufa', precio: 27.0, cantidad: 1 },
      { itemId: 'b1', nombre: 'Inca Kola (500ml)', precio: 8.0, cantidad: 1 },
    ],
    observacion: 'Sin ají',
  },
  {
    id: 'ord-8',
    zoneId: 1,
    tipo: 'bar',
    mesaId: null,
    estado: 'abierto',
    mozo: 'Carlos Ruiz',
    produccionEstado: 'entrega_pendiente',
    ordenProduccion: {
      id: 'OP-DEMO-0008',
      pedidoId: 'ord-8',
      fechaEnvioCocina: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
      fechaTerminadoCocina: new Date(Date.now() - 1000 * 60 * 2).toISOString(),
      zonaNombre: 'Planta baja',
      mesaLabel: 'Barra',
      mozo: 'Carlos Ruiz',
      observacionPedido: '',
      items: [
        { itemId: 'e2', nombre: 'Anticucho (unidad)', precio: 10.0, cantidad: 3, subtotal: 30.0 },
      ],
      total: 30.0,
    },
    createdAt: new Date(Date.now() - 1000 * 60 * 32).toISOString(),
    items: [{ itemId: 'e2', nombre: 'Anticucho (unidad)', precio: 10.0, cantidad: 3 }],
    observacion: '',
  },
];

const round2 = (n) => Math.round(Number(n || 0) * 100) / 100;

/**
 * Asegura campos de producción en pedidos antiguos (localStorage).
 * @param {object} o
 */
export function normalizeOrder(o) {
  if (!o || typeof o !== 'object') return o;
  let pe = o.produccionEstado;
  if (pe === 'disponible_entrega') pe = 'entrega_pendiente';
  const valid =
    pe === 'pendiente' || pe === 'en_cocina' || pe === 'entrega_pendiente' || pe === 'entregado';
  return {
    ...o,
    produccionEstado: valid ? pe : 'pendiente',
    ordenProduccion: o.ordenProduccion && typeof o.ordenProduccion === 'object' ? o.ordenProduccion : null,
  };
}

/**
 * Agrupa ítems por `itemId` y suma cantidades (consolidado de salida por pedido).
 * @param {Array} items
 * @returns {Array<{ itemId: string, nombre: string, precio: number, cantidad: number, subtotal?: number }>}
 */
export function consolidarItemsSalida(items) {
  const map = new Map();
  (items || []).forEach((it) => {
    const key = String(it.itemId || it.nombre || '');
    const cant = Number(it.cantidad || 0);
    const precio = Number(it.precio || 0);
    if (!key) return;
    if (!map.has(key)) {
      map.set(key, {
        itemId: it.itemId,
        nombre: it.nombre,
        precio,
        cantidad: 0,
      });
    }
    const row = map.get(key);
    row.cantidad = Number(row.cantidad) + cant;
    row.subtotal = round2(row.precio * row.cantidad);
  });
  return Array.from(map.values());
}

/**
 * Insumos de la receta escalados por cantidad de platos pedidos (demo).
 * @param {string} itemId id del ítem del menú (e1, p1…)
 * @param {number} cantidadPlatos cantidad de ese plato en el pedido
 */
export function expandInsumosReceta(itemId, cantidadPlatos) {
  const q = Math.max(0, Number(cantidadPlatos || 0));
  const list = MOCK_INSUMOS_RECETA[itemId];
  if (!list || !list.length) return [];
  return list.map((row) => {
    const cant = round2(row.cantidad * q);
    const costoLinea = round2(Number(row.costoUnit) * cant);
    return {
      nombre: row.nombre,
      cantidad: cant,
      unidad: row.unidad,
      costoUnit: Number(row.costoUnit),
      costoLinea,
    };
  });
}

/** Genera el detalle de orden de producción al pasar a cocina. */
export function buildOrdenProduccion(order) {
  const zona = MOCK_ZONAS.find((z) => z.id === order.zoneId);
  const items = (order.items || []).map((it) => {
    const cantidad = Number(it.cantidad || 0);
    const precio = Number(it.precio || 0);
    return {
      ...it,
      cantidad,
      precio,
      subtotal: round2(precio * cantidad),
    };
  });
  const total = round2(items.reduce((s, it) => s + it.subtotal, 0));
  return {
    id: `OP-${Date.now()}`,
    pedidoId: order.id,
    fechaEnvioCocina: new Date().toISOString(),
    zonaNombre: zona?.nombreZona || String(order.zoneId),
    mesaLabel: order.tipo === 'bar' ? 'Barra' : `Mesa ${order.mesaId}`,
    mozo: order.mozo || '',
    observacionPedido: order.observacion || '',
    items,
    total,
  };
}

export function getOrdersMock() {
  try {
    const raw = localStorage.getItem(LS_ORDERS_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed.map((o) => normalizeOrder(o));
    }
  } catch (_) {
    // ignore
  }
  return MOCK_INITIAL_ORDERS.map((o) => normalizeOrder({ ...o }));
}

export function setOrdersMock(orders) {
  try {
    localStorage.setItem(LS_ORDERS_KEY, JSON.stringify(orders));
  } catch (_) {
    // ignore
  }
}

export function seedOrdersMock() {
  const seeded = MOCK_INITIAL_ORDERS.map((o) => normalizeOrder({ ...o }));
  setOrdersMock(seeded);
  return seeded;
}

export function formatMoney(amount) {
  const n = Number(amount || 0);
  return n.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function getMesaHabilitacion() {
  try {
    const raw = localStorage.getItem(LS_MESA_HABILITACION_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object') return parsed;
    }
  } catch (_) {
    // ignore
  }
  return {};
}

/**
 * @param {number|string} zoneId
 * @param {number|string} mesaId - número de mesa o la cadena 'bar' para barra
 * @param {'disponible'|'ocupada'} estado
 * @returns {Record<string, Record<string, string>>}
 */
export function updateMesaHabilitacion(zoneId, mesaId, estado) {
  const all = { ...getMesaHabilitacion() };
  const z = String(zoneId);
  if (!all[z]) all[z] = {};
  all[z] = { ...all[z], [String(mesaId)]: estado };
  try {
    localStorage.setItem(LS_MESA_HABILITACION_KEY, JSON.stringify(all));
  } catch (_) {
    // ignore
  }
  return all;
}

